import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import Sidebar from "../sidebar/sidebar";
import { all_routes } from "../../router/all_routes";
import PacoteForm from "./PacoteForm";
import PacoteList from "./PacoteList";

import styles from "./style/PacotesSection.module.css";

// types
type PacoteDTO = {
  id?: number;
  titulo: string;
  descricao: string;
  precoBase: number;            // antes: preco
  duracaoEmMinutos: number;     // antes: duracao
  idiomas: string[];
  idadeMinima: number;
  publicoAlvo: string;          // antes: string[]
  fotos?: string[];
  videos?: string[];
};


const PacotesSection = () => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const [empresaId, setEmpresaId] = useState<number | null>(null);
  const [pacotes, setPacotes] = useState<PacoteDTO[]>([]);
  const [editingPacote, setEditingPacote] = useState<PacoteDTO | null>(null);
  const [activeTab, setActiveTab] = useState<"form" | "list">("form");

  // Breadcrumbs
  const breadcrumbs = [
    { label: "Dashboard", path: "/" },
    { label: "Pacotes" },
  ];

  // buscar empresa do usuário logado
  useEffect(() => {
    if (!token) return;
    axios
      .get(`${BASE_URL}/empresas/minha`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setEmpresaId(res.data.id))
      .catch((err) => console.error("Erro ao buscar empresa:", err));
  }, [BASE_URL, token]);

  const [resumos, setResumos] = useState<Record<number, { media: number; total: number }>>({});

  // carregar pacotes da empresa
  useEffect(() => {
    if (!empresaId) return;
    axios
      .get(`${BASE_URL}/pacotes/empresa/${empresaId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(async (res) => {
        const pacotes = res.data;
        setPacotes(pacotes);

        // buscar resumos de avaliações
        const responses = await Promise.all(
          pacotes.map((p: PacoteDTO) =>
            axios
              .get(`${BASE_URL}/avaliacoes/pacote/${p.id}/resumo`)
              .then((r) => ({ id: p.id!, resumo: r.data }))
              .catch(() => ({ id: p.id!, resumo: { media: 0, total: 0 } }))
          )
        );

        const map: Record<number, { media: number; total: number }> = {};
        responses.forEach((r) => (map[r.id] = r.resumo));
        setResumos(map);
      })
      .catch((err) => console.error("Erro ao carregar pacotes:", err));
  }, [empresaId, BASE_URL, token]);


  const handleSave = (novo: PacoteDTO) => {
    if (novo.id) {
      setPacotes((prev) => prev.map((p) => (p.id === novo.id ? novo : p)));
    } else {
      setPacotes((prev) => [...prev, novo]);
    }
    setActiveTab("list");
    setEditingPacote(null);
  };

  const handleEdit = (pacote: PacoteDTO) => {
    setEditingPacote(pacote);
    setActiveTab("form");
  };

  const handleDelete = async (id: number) => {
    try {
      await axios.delete(`${BASE_URL}/pacotes/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPacotes((prev) => prev.filter((p) => p.id !== id));
    } catch (err) {
      console.error("Erro ao excluir pacote:", err);
    }
  };

  if (!empresaId) return <div>Carregando...</div>;

  return (
    <div>
      {/* Breadcrumb */}
      <Breadcrumb
        title="Meus Pacotes"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-04"
      />

      {/* Conteúdo principal */}
      <div className="content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-xl-3 col-lg-4">
              <Sidebar />
            </div>

            {/* Main Content */}
            <div className="col-xl-9 col-lg-8">
              <div className="card settings mb-0">
                <div className="card-header">
                  <h6>Gerenciar Pacotes</h6>
                </div>
                <div className="card-body pb-3">
                  {/* Tabs */}
                  <div className={styles.tabs}>
                    <button
                      className={activeTab === "form" ? styles.activeTab : ""}
                      onClick={() => setActiveTab("form")}
                    >
                      Formulário
                    </button>
                    <button
                      className={activeTab === "list" ? styles.activeTab : ""}
                      onClick={() => setActiveTab("list")}
                    >
                      Lista de Pacotes
                    </button>
                  </div>

                  <div className={styles.tabContent}>
                    {activeTab === "form" && (
                      <PacoteForm
                        BASE_URL={BASE_URL!}
                        token={token}
                        empresaId={empresaId}
                        pacote={editingPacote}
                        onSave={handleSave}
                        onCancel={() => setEditingPacote(null)}
                      />
                    )}
                    {activeTab === "list" && (
                      <PacoteList
                        pacotes={pacotes}
                        resumos={resumos}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        BASE_URL={BASE_URL!}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* /Main Content */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PacotesSection;